import Vue from 'vue';
import Vuex from 'vuex';

// Module
import form from './form';
import calls from './calls';
import client from './client';
import lawyer from './lawyer';
import search from './search';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    appURL: 'http://localhost:8080/',
    locales: ['en', 'fr', 'nl'],
    locale: 'fr',
    displayApp: true
  },
  mutations: {
    setLang(state, locale) {
      state.locale = locale;
    },
    setDisplayApp(state, flag) {
      state.displayApp = flag;
    }
  },
  actions: {
    // SET_LANG({ state, commit }, locale) {
    //   if (state.locales.indexOf(locale) !== -1) {
    //     commit('setLang', locale);
    //     // this._vm.$i18n.locale = locale;
    //   }
    // }
  },
  modules: {
    form,
    calls,
    lawyer,
    search,
    client
  }
})
